import { onAuthStateChanged, signInWithEmailAndPassword, signOut as firebaseSignOut } from 'firebase/auth';
import { getFirebaseAuth } from './firebase';

function mapUser(user) {
  if (!user) return null;
  return {
    uid: user.uid,
    email: user.email || 'Sin correo',
    displayName: user.displayName || user.email || 'Operador',
    photoURL: user.photoURL || null,
    emailVerified: user.emailVerified
  };
}

export function getCurrentSession() {
  const auth = getFirebaseAuth();
  return mapUser(auth.currentUser);
}

export function observeAuthState(callback) {
  const auth = getFirebaseAuth();
  return onAuthStateChanged(auth, user => {
    callback(mapUser(user));
  });
}

export async function signIn(email, password) {
  if (!email || !password) {
    throw new Error('Ingresa correo y contraseña válidos');
  }
  const auth = getFirebaseAuth();
  const credentials = await signInWithEmailAndPassword(auth, email, password);
  return mapUser(credentials.user);
}

export async function signOut() {
  const auth = getFirebaseAuth();
  await firebaseSignOut(auth);
}
